import React, { Component } from "react";
import Cinema from "./Cinema";
import _ from "lodash";

class CinemaShowtimesResults extends Component {
  render() {
    if (!this.props.results.showtimes) {
      return <div />;
    }
    const {
      showtimes,
      location,
      timeFrom,
      timeTo,
      movies,
      cinema
    } = this.props.results;
    const byMovie = _.groupBy(this.props.results.showtimes.filter(o => o.movie_id), "movie_id");

    return (
      <div className="page cinema-showtimes-results">
        <h2>
          {showtimes.length > 0
            ? "Movies playing at " +
                cinema.name
            : ""}
        </h2>
        <h3>List of Cinemas</h3>
        {_.map(byMovie, (sessions, id) => {
          return <Cinema key={id} showtimes={sessions} cinema={movies[id]} />;
        })}
      </div>
    );
  }
}

export default CinemaShowtimesResults;



// WEBPACK FOOTER //
// ./src/components/CinemaShowtimesResults.js